/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { SetPrimaryRequestBuilderRequestsMetadata, type SetPrimaryRequestBuilder } from './setPrimary/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/v{version}/RegulatoryCharacteristics
 */
export interface RegulatoryCharacteristicsRequestBuilder extends BaseRequestBuilder<RegulatoryCharacteristicsRequestBuilder> {
    /**
     * The SetPrimary property
     */
    get setPrimary(): SetPrimaryRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const RegulatoryCharacteristicsRequestBuilderUriTemplate = "{+baseurl}/api/v{version}/RegulatoryCharacteristics";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const RegulatoryCharacteristicsRequestBuilderNavigationMetadata: Record<Exclude<keyof RegulatoryCharacteristicsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    setPrimary: {
        requestsMetadata: SetPrimaryRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
